import './App.css';
import './index.css';

export function Writing() {
  return (
    <>
      <h1 className='title'>Writing & Analysis</h1>
      <ul className='writing'>
        <li className='text-xl'>
          <a href='https://rutgers.box.com/s/czea5tnn21y1g8509npes56qkrb2lwfi' target="_blank">San Francisco: The Bleeding Edge</a>
        </li>
        <li className='text-xl'>
          <a href="https://rutgers.box.com/s/jhkix3dy2vo5wvh9n3bje26umxq81e8f" target='_blank'>Homelessness: An Investigation</a>
        </li>
        <li className='text-xl'>
          <a href="https://irosenb-portfolio.s3.us-west-2.amazonaws.com/Funding+Memorandum+FINAL.pdf" target='_blank'>Funding Memorandum</a>
        </li>
        <li className="text-xl">
          <a href="https://irosenb-portfolio.s3.us-west-2.amazonaws.com/Expanding+Housing+Choice.pdf" target='_blank'>Expanding Housing Choice</a>
        </li>
      </ul>
    </>
  )
}